import { setSelectedLocations, store } from "@redux";
import { logout, removeJwt, resetSavedCart } from "@redux";
import { ssPathname } from "./storage";
import { DEFAULT_COUNTRY, SIGN_IN_PROMPT_SEEN_KEY } from "@constants";
import { resetCheckout } from "src/Module/Checkout/checkout";
import { sessionHelper } from "./sessionHelper";
import { clearGuestCartStash } from "src/Module/Checkout/guestCartStash";

export const performLogoutActions = async () => {
    ssPathname.removeItem();
    sessionHelper.clearSession();
    store.dispatch(resetCheckout());
    await store.dispatch(logout());
    await store.dispatch(removeJwt());
    store.dispatch(resetSavedCart());
    store.dispatch(
        setSelectedLocations({
            country: DEFAULT_COUNTRY,
            state: null,
            region: null,
            locality: null,
        }),
    );

    // The prompt is a once-per-session offer; without clearing it the next
    // visitor on this browser would silently skip straight past the sign-up sheet.
    try {
        sessionStorage.removeItem(SIGN_IN_PROMPT_SEEN_KEY);
    } catch (e) {
        console.warn("Failed to clear the sign-in prompt flag on logout:", e);
    }

    // Anything still queued belongs to the session that just ended; leaving it
    // would replay this person's products into the next sign-up on this browser.
    clearGuestCartStash();

    // Clear checkout step on logout
    try {
        localStorage.removeItem("checkout-step");
    } catch (e) {
        console.warn("Failed to clear checkout step on logout:", e);
    }

    // Clear Apple OAuth temp storage
    try {
        localStorage.removeItem("appleLoginReturnPath");
        const { ssStorage } = await import("./storage");
        const tempJwt = ssStorage("tempJwt");
        tempJwt.removeItem();
    } catch (e) {
        console.warn("Failed to clear Apple OAuth temp storage on logout:", e);
    }

    sessionStorage.removeItem("guestCheckoutInProgress");
};
